import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { BatchTypeFormValues } from "src/models/BatchType.model";
import BatchType from "../Layouts/BatchTypeForm";
import { useAddBatchTypeMutation } from "src/services/BatchTypeService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddBatchTypeWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const [addBatchType] = useAddBatchTypeMutation();

  const initialValues: BatchTypeFormValues = {
    batchTypeName: "",
    batchTypeCode: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    batchTypeName: string().required("Please enter Batch Type name"),
    batchTypeCode: string().required("Please enter Batch Type code"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BatchTypeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BatchTypeFormValues>
  ) => {
    const payload = {
      batchTypeName: values.batchTypeName,
      batchTypeCode: values.batchTypeCode,
    };
    addBatchType(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <BatchType formikProps={formikProps} onClose={onClose} formType="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddBatchTypeWrapper;